import { IProfilingCode } from 'legacy/lut/classes/models/profiling/codes'

import { IOrderManagementItem } from 'clickNgo/models/order'

import { HEADQUARTERS_ONLY_FLAGS } from '../configs'

interface IApplyOrderManagementConditions {
  isHQ: boolean
  orderManagementList: IOrderManagementItem[]
}

export const applyOrderManagementConditions = ({
  isHQ,
  orderManagementList,
}: IApplyOrderManagementConditions) => {
  return (profilingCodeList: IProfilingCode[]) => {
    if (!isHQ) {
      return profilingCodeList
    }

    return profilingCodeList.map((profiling) => {
      const requirement = HEADQUARTERS_ONLY_FLAGS[profiling.code]
      const requiredFlags = requirement?.requiredFlags || []
      const match = orderManagementList.find((it) => {
        return requiredFlags.some((part) => it.systemType.toLowerCase().includes(part))
      })

      if (requirement && !match) {
        return {
          ...profiling,
          comment: requirement.noRequiredFlagsMessage,
        }
      }

      return profiling
    })
  }
}
